import { BASE_PATH_API } from 'constants/env';
import axios from 'axios';

async function getZipCode(zipcode) {
  const res = await axios({
    url: `${BASE_PATH_API}/shipping/v1/zoning/${zipcode}`,
  });
  return res.data;
}

export default getZipCode;
